import React from "react";
import AppRoutes from "../routes";
import HomePage from "../pages/elfinstudio/pages/home";
const ElfinStudioTemplate = () => {
    return (
        <>
            <div className="bg-[#F0F4FE] min-h-screen overflow-hidden">
                <AppRoutes homePage={HomePage} />
            </div>
        </>
    );
};

export default ElfinStudioTemplate;
